// extracted by mini-css-extract-plugin
module.exports = {"cls1":"BlankSlate-module--cls1--1Izzw","cls2":"BlankSlate-module--cls2--DzqKx BlankSlate-module--cls1--1Izzw p-6"};